import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    快速导航: [
      { label: '首页', to: '/' },
      { label: '入门指南', to: '/category/rumen' },
      { label: '使用技巧', to: '/category/jiqiao' },
      { label: '关于我们', to: '/about' },
    ],
    服务支持: [
      { label: '常见问题', to: '/category/wenti' },
      { label: '安全与隐私', to: '/category/anquan' },
      { label: '版本更新', to: '/category/gengxin' },
      { label: '多端使用', to: '/category/duan' },
    ],
    关于我们: [
      { label: '品牌介绍', to: '/about' },
      { label: '发展历程', to: '/about' },
      { label: '联系我们', to: '/about' },
    ],
  };

  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-flashlight-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-heading font-bold text-white">
                爱液网页版
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mt-3">
              无需下载安装，打开浏览器即可使用的在线服务平台。支持PC与手机多端访问，随时随地轻松使用。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-white mb-4">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 hover:text-white transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 爱液网页版 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="mailto:support@aiye.com" className="text-xs text-foreground-500 hover:text-white transition-colors">
              support@aiye.com
            </a>
            <span className="text-foreground-700">|</span>
            <span className="text-xs text-foreground-500">400-888-9999</span>
          </div>
        </div>
      </div>
    </footer>
  );
}